import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import findLastIndex from 'lodash-es/findLastIndex';
import { TimeoutService } from '@df/ng/timeout.service';

export type IAppBusyState = IAppBusyStateMessage | IAppBusyStateTemplatePortal;

export interface IAppBusyStateBasic {
    // if we don't want timeout just pass 0
    timeout?: number;
    priority?: number;
}

export interface IAppBusyStateMessage extends IAppBusyStateBasic {
    message: string;
}

export interface IAppBusyStateTemplatePortal extends IAppBusyStateBasic {
    templatePortal?: TemplatePortal<any>;
}

@Injectable({
    providedIn: 'root'
})
export class AppBusyStateService {
    protected activeState: IAppBusyState | undefined;

    protected subject = new Subject<IAppBusyState | undefined>();

    protected defaultTimeout = 30000;

    private busyStates: IAppBusyState[] = [];
    constructor(private timeoutService: TimeoutService) {}

    add(busyState: IAppBusyState): () => void {
        const priority = busyState.priority;
        const position =
            priority === undefined
                ? this.busyStates.length
                : findLastIndex(this.busyStates, state => state.priority !== undefined && state.priority > priority);
        this.busyStates.splice(position, 0, busyState);

        if (position === 0) {
            this.next();
        }

        let timeout;

        const destroy = () => {
            clearTimeout(timeout);
            const index = this.busyStates.indexOf(busyState);
            if (index > -1) {
                this.busyStates.splice(index, 1);
            }
            if (index === 0) {
                this.next();
            }
        };
        const duration = busyState.timeout !== undefined ? busyState.timeout : this.defaultTimeout;
        if (duration) {
            timeout = this.timeoutService.setTimeout(() => destroy(), duration);
        }
        return destroy;
    }

    subscribe(...args): Subscription {
        return this.subject.subscribe(...args);
    }

    protected get current(): IAppBusyState | undefined {
        return this.busyStates[0];
    }

    protected next(): void {
        this.subject.next(this.current);
    }
}
